/**
 * "The user picked this app for this file" — the host-side record that lets a
 * plugin handoff skip its confirmation (ADR-030).
 *
 * Opening a file in a plugin grants that plugin the file. When the user
 * clicked "Open in WordFlow" in My Data, that click IS the consent. But a
 * handoff can also come from the assistant (whose turn may be steered by
 * content it read) or from another plugin's `open_arche` — and there the
 * user chose nothing, so the host asks first.
 *
 * In-memory and single-use, on purpose: never navigation state (which the
 * intake treats as forgeable) and never storage. A record is consumed by the
 * one handoff it names and expires quickly, so it cannot be replayed.
 */

const TTL_MS = 2 * 60 * 1000;
const chosen = new Map<string, number>();

const key = (archeId: string, documentId: string) => `${archeId}\u0000${documentId}`;

/** Record a direct user choice ("Open in <app>") just before the handoff. */
export function noteUserChoseApp(archeId: string, documentId: string, now = Date.now()): void {
  chosen.set(key(archeId, documentId), now + TTL_MS);
}

/** Was this exact handoff a direct user choice? Consumes the record. */
export function consumeUserChoice(archeId: string, documentId: string, now = Date.now()): boolean {
  const k = key(archeId, documentId);
  const expiresAt = chosen.get(k);
  chosen.delete(k);
  return expiresAt !== undefined && expiresAt > now;
}
